export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6735.6afc9734.jpg";